import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Spinner } from 'react-bootstrap';

export const LoadingState = () => (
    <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
    </div>
);

export const ErrorBanner = ({ message, onRetry, variant = 'danger', prefix = '' }) => (
    <Alert variant={variant} className="d-flex justify-content-between align-items-center">
        <span>{prefix}{message}</span>
        <Button size="sm" variant={`outline-${variant}`} onClick={onRetry}>Retry</Button>
    </Alert>
);

ErrorBanner.propTypes = {
    message: PropTypes.string.isRequired,
    onRetry: PropTypes.func.isRequired,
    variant: PropTypes.oneOf(['danger', 'warning']),
    prefix: PropTypes.string
};

export const EmptyState = ({ children, className = '' }) => (
    <Alert variant="info" className={className}>{children}</Alert>
);

EmptyState.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
